import { useState } from "react";

const useToast=({afterClose})=>{
    const [openToast, setOpenToast] = useState(null);
  const [toastText, setToastText] = useState([]);
  const [colorToast, setColorToast] = useState("");
  const handleSuccess = (text) => {
    setToastText((prev) => [
      ...prev,
      { text: text ? text : "با موفقیت انجام شد" },
    ]);
    setOpenToast(true);
    setColorToast("rgba(76, 175, 80, 1)");
    //close invoice modal
    setTimeout(() => {
      if(afterClose)afterClose(null);
    }, 1000);
  };

  const handleFailed = (text) => {
    setOpenToast(true);
    setToastText((prev) => [
      ...prev,
      { text: text ? text : "  خطایی رخ داد !" },
    ]);
    setColorToast("rgba(212, 22, 79, 1)");
  };
  const closeToast = () => {
    setOpenToast(false);
    setToastText([]);
    setColorToast("");
  }
  return { openToast, toastText, colorToast, handleSuccess, handleFailed,setOpenToast ,setToastText,closeToast};
}
export default useToast;